"use client";

import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import Image from "next/image";
import React from "react";
import { UpgradeSuccessContentProps } from "./types";
import Translations from "@translate/components/Payment/UpgradeSuccessModal/UpgradeSuccessContent";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export interface UpgradeSuccessContentWithCloseProps extends UpgradeSuccessContentProps {
  onClose: () => void;
}

/** 升级成功弹窗内容（PC Modal / 移动端 DrawerH5 共用） */
export const UpgradeSuccessContent: React.FC<
  UpgradeSuccessContentWithCloseProps
> = ({ onSuccessFunction, className }) => {
  const handleGetStarted = () => {
    onSuccessFunction?.();
  };

  return (
    <div
      className={cn(
        "relative flex w-full flex-col items-center gap-10 bg-background_solid_neutral_primary p-8",
        "max-md:rounded-4 md:rounded-2xl",
        className,
      )}
    >
      <div className="flex w-full flex-col items-center gap-4">
        <div className="inline-flex shrink-0 items-end gap-1">
          <Icon
            name="pricing"
            size={24}
            className="text-content_accent4_primary mt-2"
          />
          <picture>
            <Image
              src="/edgen_logo_full_v2.svg"
              alt=""
              width={56}
              height={32}
              className="h-8"
            />
          </picture>
        </div>
        <div className="flex w-full flex-col items-center gap-1 text-center">
          <p className="headline_regular_m w-fit whitespace-nowrap text-content_primary">
            {I18n.t("Payment Successful")}
          </p>
          <p className="body_m w-full text-content_secondary">
            {I18n.t("Membership & perks arriving in minutes.")}
          </p>
        </div>
      </div>
      <button
        type="button"
        data-openreplay-label={`UpgradeSuccessContent · Button | ${I18n.t("Get started")}`}
        onClick={handleGetStarted}
        className="button button_m primary_button md_button h-11 w-full min-w-[80px] shrink-0 rounded-2 px-4 py-3 text-content_inverse_primary"
      >
        {I18n.t("Get started")}
      </button>
    </div>
  );
};
